import { FC, useEffect, useState } from 'react'

import { Container } from 'components/container'
import { Share } from '../share'
import { StyledNav, Logo, LogoContainer, Content } from './styled'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { useAppContext } from 'context/app-context'

export const Header: FC<{
  onTop?: boolean
  isTransparent: boolean
  inverted: boolean
}> = () => {
  const { logoUrl } = useAppContext()
  const isLarge = useMedia([breakpoints.medium], [true], false)
  const [isShareExpanded, setShareExpanded] = useState(isLarge)
  const isContentVisible = isLarge || !isShareExpanded

  useEffect(() => {
    if (!isLarge && isShareExpanded) {
      setShareExpanded(false)
    } else if (isLarge && !isShareExpanded) {
      setShareExpanded(true)
    }
  }, [isLarge])

  return (
    <>
      <StyledNav>
        <Container $fluid>
          <LogoContainer
            animate={{
              opacity: isContentVisible ? 1 : 0,
              transition: { delay: isContentVisible ? 0.3 : 0 },
            }}
            href="/"
          >
            <Logo src={logoUrl} />
          </LogoContainer>

          <Content>
            <Share
              isShare
              isVisible={isShareExpanded}
              onToggle={() => setShareExpanded(v => !v)}
              onOpen={() => setShareExpanded(true)}
              onClose={() => setShareExpanded(false)}
            />
          </Content>
        </Container>
      </StyledNav>
    </>
  )
}
